import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";

import CTAButton from "./Button";
import HighlightText from "./HighlightText";
import { DS } from "../../../utils/designSystem";
import { fadeIn } from "../../common/motionFrameVarients";

import Instructor from "../../../assets/Images/Instructor.jpg";
import iconCourse   from "../../../assets/Images/Instructor/course.png";
import iconTeaching from "../../../assets/Images/Instructor/creative-teaching.png";
import iconTransfer from "../../../assets/Images/Instructor/knowledge-transfer.png";

const BENEFITS = [
  {
    title: "Teach your way",
    description:
      "Shape your courses according to your preferences and retain complete control over your content at all times.",
    icon: iconCourse,
  },
  {
    title: "Inspire learners",
    description:
      "Guide learners in discovering their passions, acquiring fresh skills, and progressing in their careers.",
    icon: iconTeaching,
  },
  {
    title: "Get rewarded",
    description:
      "Grow your professional connections and generate income with each paid enrollment.",
    icon: iconTransfer,
  },
];

const InstructorSection = () => {
  return (
    <div className="flex flex-col items-center gap-16 lg:flex-row lg:gap-20">

      {/* ── Image ── */}
      <motion.div
        variants={fadeIn("right", 0.1)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        className="lg:w-[42%] flex-shrink-0"
      >
        <div className="relative">
          <img
            src={Instructor}
            alt="Instructor"
            className="w-full rounded-2xl object-cover shadow-[-16px_-16px_0_0_rgba(255,214,10,0.15)] ring-1 ring-richblack-700"
          />
          {/* Floating accent */}
          <div className={`absolute -bottom-5 -right-5 ${DS.card.base} ${DS.card.padSm} ${DS.shadow.card}`}>
            <p className="text-xs text-richblack-300">Students taught</p>
            <p className="text-xl font-bold text-richblack-5">10,000+</p>
          </div>
        </div>
      </motion.div>

      {/* ── Content ── */}
      <motion.div
        variants={fadeIn("left", 0.1)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        className="flex flex-col gap-8 lg:w-[58%]"
      >
        <div>
          <h2 className="text-3xl lg:text-4xl font-semibold text-richblack-5">
            Become an <HighlightText text="instructor" />
          </h2>
          <p className={`${DS.text.body} mt-4 max-w-lg`}>
            Instructors from around the world teach millions of students on
            KodeVedic. We provide the tools and skills to teach what you love.
          </p>
        </div>

        <CTAButton active={true} linkto="/signup">
          <div className="flex items-center gap-2">
            Start Teaching Today
            <FaArrowRight />
          </div>
        </CTAButton>

        {/* Benefit cards - dark themed */}
        <div className="grid gap-4 sm:grid-cols-3">
          {BENEFITS.map(({ title, description, icon }) => (
            <div
              key={title}
              className={`flex flex-col items-center text-center gap-3 ${DS.card.base} ${DS.card.hover} ${DS.card.padSm}`}
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-richblack-700 p-2">
                <img src={icon} alt={title} className="h-10 w-10 object-contain" />
              </div>
              <h3 className="text-sm font-semibold text-richblack-5">{title}</h3>
              <p className="text-xs text-richblack-300 leading-relaxed">{description}</p>
            </div>
          ))}
        </div>
      </motion.div>

    </div>
  );
};

export default InstructorSection;
